var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1191 24.8565C19.2931 24.9527 19.4839 24.9996 19.6747 24.9996C19.9243 24.9996 20.1727 24.9185 20.3803 24.7565C20.7499 24.4729 20.9335 23.993 20.8567 23.5182L19.6903 16.3924L24.6345 11.3469C24.9645 11.0113 25.0821 10.5074 24.9417 10.0478C24.8025 9.58819 24.4257 9.25393 23.9733 9.18429L17.1318 8.13593L14.0752 1.64573C13.6696 0.784757 12.3303 0.784757 11.9247 1.64573L8.86823 8.13593L2.02671 9.18429C1.57428 9.25393 1.19747 9.58819 1.05826 10.0478C0.917852 10.5074 1.03546 11.0113 1.36547 11.3469L6.30971 16.3924L5.14325 23.5182C5.06645 23.993 5.25006 24.4729 5.61968 24.7565C5.98569 25.0401 6.47532 25.0793 6.88094 24.8565L13 21.4835L19.1191 24.8565Z",
    fill: "transparent",
    stroke: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9176d145fe69efa0cfe98c1a91fc53d3.svg";
export { ForwardRef as ReactComponent };